<template>
  <div class="info-page-container d-flex flex-column min-vh-100">
    <!-- Header -->
    <Header />

    <main class="info-main-content flex-grow-1 py-4">
      <div class="container px-3 max-width-md mx-auto">
        <!-- Brand Header Card -->
        <section class="info-card brand-showcase-card mb-4 text-center">
          <div class="brand-badge-icon mx-auto mb-3">
            <img src="@/assets/img/loidoc_logo_custom.png" alt="Lối Đọc" class="brand-badge-logo-img" />
          </div>
          <h1 class="brand-title font-serif mb-2">Lối Đọc</h1>
          <p class="brand-motto text-muted mb-3">
            Mạng xã hội đọc sách &amp; Sàn giao dịch sách cũ C2C an toàn cho độc giả Việt Nam.
          </p>
          <div class="version-badge d-inline-flex align-items-center gap-1">
            <span>Phiên bản 1.0.0</span>
          </div>
        </section>

        <!-- App Download Section -->
        <section class="info-card mb-4">
          <div class="card-header-clean mb-3">
            <h2 class="section-heading h6 m-0 font-serif fw-bold">
              <icon icon="fa-solid fa-mobile-screen-button" class="me-2 text-primary-color" />
              Tải ứng dụng Lối Đọc
            </h2>
          </div>
          <p class="card-sub-desc text-muted mb-3">
            Trải nghiệm đọc sách, đánh dấu trang và trao đổi sách thuận tiện nhất trên điện thoại của bạn.
          </p>
          <div class="store-buttons-grid d-flex flex-column flex-sm-row gap-3">
            <a href="#" class="btn-app-store" title="Tải trên App Store" @click.prevent>
              <icon :icon="['fab', 'apple']" class="store-icon" />
              <div class="store-text">
                <span class="store-sub">DOWNLOAD ON THE</span>
                <strong class="store-title">App Store</strong>
              </div>
            </a>
            <a href="#" class="btn-app-store" title="Tải trên Google Play" @click.prevent>
              <icon :icon="['fab', 'google-play']" class="store-icon" />
              <div class="store-text">
                <span class="store-sub">GET IT ON</span>
                <strong class="store-title">Google Play</strong>
              </div>
            </a>
          </div>
        </section>

        <!-- Company & Legal Links Section -->
        <section class="info-card mb-4">
          <div class="card-header-clean mb-3">
            <h2 class="section-heading h6 m-0 font-serif fw-bold">
              <icon icon="fa-solid fa-scale-balanced" class="me-2 text-primary-color" />
              Công ty &amp; Pháp lý
            </h2>
          </div>
          <div class="info-nav-list d-flex flex-column gap-2">
            <a href="https://kientaotech.com/" target="_blank" rel="noopener noreferrer" class="info-nav-row text-decoration-none">
              <div class="d-flex align-items-center gap-3">
                <div class="row-icon-box">
                  <icon icon="fa-solid fa-arrow-up-right-from-square" />
                </div>
                <div class="text-start">
                  <span class="row-title d-block">Về Kiến Tạo Tech (About Us)</span>
                  <span class="row-sub text-muted">Trang chủ kientaotech.com</span>
                </div>
              </div>
              <icon icon="fa-solid fa-arrow-up-right-from-square" class="chevron-icon fs-7" />
            </a>

            <button class="info-nav-row" @click="openModal('terms')">
              <div class="d-flex align-items-center gap-3">
                <div class="row-icon-box">
                  <icon icon="fa-solid fa-file-contract" />
                </div>
                <div class="text-start">
                  <span class="row-title d-block">Điều khoản dịch vụ (Terms)</span>
                  <span class="row-sub text-muted">Quy định sử dụng và giao dịch cộng đồng</span>
                </div>
              </div>
              <icon icon="fa-solid fa-chevron-right" class="chevron-icon" />
            </button>

            <button class="info-nav-row" @click="openModal('privacy')">
              <div class="d-flex align-items-center gap-3">
                <div class="row-icon-box">
                  <icon icon="fa-solid fa-lock" />
                </div>
                <div class="text-start">
                  <span class="row-title d-block">Chính sách bảo mật (Privacy)</span>
                  <span class="row-sub text-muted">Bảo vệ thông tin và quyền riêng tư</span>
                </div>
              </div>
              <icon icon="fa-solid fa-chevron-right" class="chevron-icon" />
            </button>

            <button class="info-nav-row" @click="openModal('help')">
              <div class="d-flex align-items-center gap-3">
                <div class="row-icon-box">
                  <icon icon="fa-solid fa-circle-question" />
                </div>
                <div class="text-start">
                  <span class="row-title d-block">Trợ giúp &amp; Báo cáo bản quyền</span>
                  <span class="row-sub text-muted">Giải đáp thắc mắc và khiếu nại nội dung</span>
                </div>
              </div>
              <icon icon="fa-solid fa-chevron-right" class="chevron-icon" />
            </button>
          </div>
        </section>

        <!-- Social & Contact Support -->
        <section class="info-card mb-4">
          <div class="card-header-clean mb-3">
            <h2 class="section-heading h6 m-0 font-serif fw-bold">
              <icon icon="fa-solid fa-globe" class="me-2 text-primary-color" />
              Kết nối &amp; Hỗ trợ
            </h2>
          </div>
          <div class="social-btn-group d-flex justify-content-center gap-3 mb-3">
            <a href="#" class="social-circle-pill" title="Facebook" @click.prevent>
              <icon :icon="['fab', 'facebook-f']" />
            </a>
            <a href="#" class="social-circle-pill" title="YouTube" @click.prevent>
              <icon :icon="['fab', 'youtube']" />
            </a>
            <a href="#" class="social-circle-pill" title="TikTok" @click.prevent>
              <icon :icon="['fab', 'tiktok']" />
            </a>
            <a href="#" class="social-circle-pill" title="Instagram" @click.prevent>
              <icon :icon="['fab', 'instagram']" />
            </a>
          </div>

          <div class="contact-details-box p-3 rounded-3 d-flex flex-column gap-3">
            <div class="contact-item d-flex align-items-center gap-3">
              <icon icon="fa-solid fa-envelope" class="contact-icon text-accent" />
              <a href="mailto:support@kientaotech.com" class="contact-link">support@kientaotech.com</a>
            </div>
            <div class="contact-item d-flex align-items-center gap-3">
              <icon icon="fa-solid fa-phone" class="contact-icon text-accent" />
              <a href="tel:0349128669" class="contact-link">0349.128.669</a>
            </div>
            <div class="contact-item d-flex align-items-start gap-3">
              <icon icon="fa-solid fa-location-dot" class="contact-icon text-accent mt-0.5" />
              <span class="contact-text text-muted">Đội 3, Thôn Phổ Lại, Xã Đan Điền, Thành Phố Huế</span>
            </div>
          </div>
        </section>

        <!-- Copyright Footer Card -->
        <footer class="info-footer-bottom text-center py-2">
          <p class="copyright-line mb-1 text-muted fs-8">
            © 2026 Lối Đọc. Tất cả các quyền được bảo hộ.
          </p>
          <p class="org-line mb-0 fs-8 text-muted">
            Một sản phẩm thuộc <strong class="text-primary-color">Kiến Tạo Tech</strong>
          </p>
        </footer>
      </div>
    </main>

    <!-- Interactive Detail Modals -->
    <div v-if="activeModal" class="info-modal-backdrop" @click="closeModal">
      <div class="info-modal-sheet" @click.stop>
        <div class="info-modal-header d-flex align-items-center justify-content-between pb-3 mb-3 border-bottom">
          <h3 class="modal-title font-serif h6 m-0 fw-bold">
            <span v-if="activeModal === 'about'">Về Kiến Tạo Tech (About Us)</span>
            <span v-else-if="activeModal === 'terms'">Điều khoản dịch vụ</span>
            <span v-else-if="activeModal === 'privacy'">Chính sách bảo mật</span>
            <span v-else-if="activeModal === 'help'">Trợ giúp &amp; Bản quyền</span>
          </h3>
          <button class="btn-close-modal" @click="closeModal" aria-label="Đóng">
            <icon icon="fa-solid fa-xmark" />
          </button>
        </div>

        <div class="info-modal-body">
          <div v-if="activeModal === 'about'" class="modal-text-content">
            <p><strong>Lối Đọc</strong> là nền tảng mạng xã hội và sàn trao đổi sách do đội ngũ <strong>Kiến Tạo Tech</strong> phát triển với sứ mệnh lan tỏa văn hóa đọc, kết nối cộng đồng yêu sách và tối ưu hóa việc quản lý tri thức cá nhân.</p>
            <p>Chúng tôi ứng dụng công nghệ gợi ý thông minh (AI), kết hợp sàn giao dịch sách cũ an toàn nhằm mang lại trải nghiệm đọc sách hiện đại, tiện lợi và tiết kiệm cho độc giả trên toàn quốc.</p>
          </div>

          <div v-else-if="activeModal === 'terms'" class="modal-text-content">
            <p>1. <strong>Tài khoản người dùng:</strong> Người dùng chịu trách nhiệm bảo mật thông tin đăng nhập và mọi hoạt động diễn ra dưới tài khoản của mình.</p>
            <p>2. <strong>Giao dịch sách cũ:</strong> Các bên tham gia giao dịch sách cũ cam kết cung cấp thông tin trung thực về tình trạng sách và tuân thủ quy trình thanh toán đảm bảo của hệ thống.</p>
            <p>3. <strong>Bình luận và Đánh giá:</strong> Nghiêm cấm các nội dung mang tính đả kích, xúc phạm hoặc vi phạm chuẩn mực đạo đức xã hội.</p>
          </div>

          <div v-else-if="activeModal === 'privacy'" class="modal-text-content">
            <p>Lối Đọc cam kết bảo mật tuyệt đối dữ liệu cá nhân của người dùng:</p>
            <p>• Dữ liệu đọc sách và tủ sách cá nhân chỉ phục vụ việc cá nhân hóa trải nghiệm và đề xuất sách.</p>
            <p>• Không chia sẻ thông tin cá nhân cho bên thứ ba khi chưa có sự đồng ý rõ ràng của người dùng.</p>
            <p>• Áp dụng các tiêu chuẩn mã hóa bảo mật hiện đại cho toàn bộ dữ liệu giao dịch.</p>
          </div>

          <div v-else-if="activeModal === 'help'" class="modal-text-content">
            <p>Nếu bạn gặp sự cố kỹ thuật hoặc phát hiện nội dung vi phạm bản quyền trên nền tảng Lối Đọc, vui lòng liên hệ trực tiếp với chúng tôi qua:</p>
            <p>• <strong>Email hỗ trợ:</strong> <a href="mailto:support@kientaotech.com" class="text-primary-color">support@kientaotech.com</a></p>
            <p>• <strong>Hotline:</strong> 0349.128.669</p>
            <p>Chúng tôi sẽ tiếp nhận và xử lý khiếu nại trong vòng 24-48 giờ làm việc.</p>
          </div>
        </div>

        <div class="info-modal-footer pt-3 mt-3 border-top text-end">
          <button class="btn btn-sm btn-outline-secondary px-4 rounded-pill" @click="closeModal">
            Đóng
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script src="./info.js"></script>
<style scoped src="./info.css"></style>
